import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#EAE3DE] bg-[#FDFBF9]" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between text-sm">
        <div className="flex items-center gap-6 flex-wrap">
          <div className="flex items-center gap-2">
            <img
              src="https://customer-assets.emergentagent.com/job_merchant-scores-1/artifacts/kmv9mriv_v3bk3q6t_file_00000000133c71fda8bb4b05261095cf.png"
              alt="Servrevu"
              className="h-8 w-auto object-contain"
            />
            <span className="text-lg font-black tracking-tight text-[#1B1614]">Servrevu</span>
          </div>
          <Link to="/directory" className="text-[#8B7B73] hover:text-[#B31E1E]" data-testid="footer-directory">Directory</Link>
          <Link to="/find-neighborhood" className="text-[#8B7B73] hover:text-[#B31E1E]" data-testid="footer-neighborhoods">Neighborhoods</Link>
          <Link to="/marketplace" className="text-[#8B7B73] hover:text-[#B31E1E]" data-testid="footer-marketplace">Marketplace</Link>
          <Link to="/list-your-business" className="text-[#8B7B73] hover:text-[#B31E1E]" data-testid="footer-list-business">List your business</Link>
          <Link to="/privacy" className="text-[#B31E1E] hover:text-[#8F1717] font-medium" data-testid="footer-privacy">Privacy</Link>
          <Link to="/terms" className="text-[#B31E1E] hover:text-[#8F1717] font-medium" data-testid="footer-terms">Terms</Link>
          <Link to="/login" className="text-[#B31E1E] hover:text-[#8F1717] font-medium" data-testid="footer-login">Contact</Link>
        </div>
        <div className="flex items-center gap-6 text-xs text-[#8B7B73]">
          <span>© {new Date().getFullYear()} Servrevu.</span>
        </div>
      </div>
    </footer>
  );
}
